import { isRTL } from "@core/shared/utils";
import { cn } from "@design-system/utils";
import { AuthHeader } from "../../../auth/components/AuthHeader";
import { EncouragingQuote } from "../../components/EncouragingQuote";

type AuthLayoutProps = {
  direction?: "left" | "right";
  children: React.ReactNode;
};

export function AuthLayout({ children, direction = "left" }: AuthLayoutProps) {
  const rtl = isRTL();

  return (
    <>
      <div
        className={cn(
          "flex min-h-screen",
          direction === "left" ? "flex-row" : "flex-row-reverse",
        )}
      >
        {/* Form Side */}
        <div className="flex flex-1 flex-col bg-white dark:bg-gray-900 transition-colors duration-300">
          <AuthHeader />
          <div className="relative flex flex-1 items-start justify-center px-8 py-8 sm:items-center sm:px-16">
            <div className="w-full max-w-[700px]">{children}</div>
          </div>
        </div>

        {/* Image Side */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="fixed inset-y-0 w-1/2 bg-gradient-to-br from-[#1e3a8a] via-[#1d4ed8] to-[#0ea5e9] dark:from-[#0f172a] dark:via-[#1e293b] dark:to-[#334155] ltr:right-0 rtl:left-0 transition-colors duration-300">
            <EncouragingQuote rtl={rtl} />
          </div>
        </div>
      </div>
    </>
  );
}
